import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import { VoucherDisclaimer } from 'components/Disclaimers';
import { LineItem } from 'components/payments/primitives';
import * as propTypes from 'components/payments/propTypes';

const VoucherLineItem = ({ total }) => (
  <LineItem title="Voucher" totals={[total]}>
    <Box>
      Vouchers are non-refundable
      <VoucherDisclaimer.Link />
    </Box>
  </LineItem>
);

VoucherLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.voucherPaymentMethod).isRequired,
};

export default VoucherLineItem;
